import React from "react";
import { media } from "@glitz/core";
import { styled } from "@glitz/react";
import { GrCheckmark } from "react-icons/gr";

const steps = [
  { number: 1, label: "Leverans" },
  { number: 2, label: "Summering" },
  { number: 3, label: "Betalning" },
  { number: 4, label: "Klar!" },
];

interface CheckoutStepsProps {
  currentStep: number; // 1 till 4
  onStepChange?: (step: number) => void;
}

export const CheckoutSteps = ({
  currentStep,
  onStepChange,
}: CheckoutStepsProps) => {
  return (
    <Wrapper className="checkout-steps">
      {steps.map((step, index) => {
        const isCompleted = step.number < currentStep;

        return (
          <StepWrapper key={step.number}>
            <Circle
              className="checkout-step-circle"
              css={[
                step.number <= currentStep && activeCircle,
                isCompleted && currentStep < 4 && clickableCircle,
              ]}
              onClick={() => {
                if (isCompleted && onStepChange && currentStep < 4) {
                  onStepChange(step.number);
                }
              }}
            >
              {isCompleted ? <GrCheckmark /> : step.number}
            </Circle>

            <Label css={step.number <= currentStep && activeLabel}>
              {step.label}
            </Label>

            {index !== steps.length - 1 && (
              <Line css={step.number < currentStep && activeLine} className="checkout-step-line" />
            )}
          </StepWrapper>
        );
      })}
    </Wrapper>
  );
};

const Wrapper = styled.div({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: { x: "16px", y: "0" },
  position: "relative",
  width: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
  overflow: "hidden",
});

const StepWrapper = styled.div({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  flex: {
    grow: "1",
    shrink: "1",
    basis: "0",
  },
  minWidth: 0,
  position: "relative",
});

const Circle = styled.div({
  width: "32px",
  height: "32px",
  borderRadius: "50%",
  backgroundColor: "#ccc",
  color: "#666",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: "bold",
  zIndex: 1,
  flexShrink: 0,
  ...media({ maxWidth: "768px" }, {
    width: "28px",
    height: "28px",
    fontSize: "13px",
  }),
});

const activeCircle = styled({
  backgroundColor: "#000",
  color: "#fff",
});

const clickableCircle = styled({
  cursor: "pointer",

  ":hover": {
    opacity: 0.85,
  },
});

const Label = styled.span({
  marginTop: "8px",
  fontSize: "12px",
  color: "#888",
  textAlign: "center",
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  ...media({ maxWidth: "768px" }, {
    fontSize: "10px",
    marginTop: "4px",
  }),
});

const activeLabel = styled({
  color: "#000",
});

const Line = styled.div({
  position: "absolute",
  top: "16px",
  left: "50%",
  width: "100%",
  height: "2px",
  backgroundColor: "#ccc",
  zIndex: 0,
  ...media({ maxWidth: "768px" }, {
    top: "14px",
  }),
});

const activeLine = styled({
  backgroundColor: "#000",
});
